import { Download } from 'lucide-react';
import { downloadCsv } from '../../services/stats/csvDownload';

interface Props {
  /** Nom du fichier sans extension (la fonction ajoute .csv si besoin). */
  filename: string;
  /** Contenu CSV déjà construit via `buildCsv`. */
  content: string;
  /** Si null/undefined ou vide, le bouton se désactive proprement. */
  disabled?: boolean;
  label?: string;
}

export function CsvExportButton({ filename, content, disabled, label = 'CSV' }: Props) {
  return (
    <button
      type="button"
      onClick={() => downloadCsv(filename, content)}
      disabled={disabled}
      className="inline-flex items-center gap-1 text-xs text-cime-text-muted hover:text-cime-primary disabled:opacity-40 disabled:cursor-not-allowed transition print:hidden"
      aria-label={`Exporter ${label}`}
    >
      <Download className="w-3.5 h-3.5" />
      {label}
    </button>
  );
}
